const GOOGLE_ANALYTICS_ID = 'UA-21170686-1';
export default GOOGLE_ANALYTICS_ID;
